import React, { useEffect, useReducer, useRef } from "react";
import PropTypes from "prop-types";
import style from "./CustomizationsPage.module.sass";
import CustomizationsPageHeader from "./CustomizationsPageHeader/CustomizationsPageHeader";
import BulkChangeActions from "./BulkChangeActions/BulkChangeActions";
import { initState, reducer } from "./CustomizationsPageState";
import ExercisesContent from "./ExercisesContent/ExercisesContent";
import { callApi } from "../../helpers";
function CustomizationsPage(props) {
  const { url } = props;
  const [state, dispatcher] = useReducer(reducer, { url }, initState);

  useEffect(() => {
    callApi(url, "GET", "json", onSuccess);
  }, []);

  const onSuccess = (data) => {
    dispatcher({
      type: "update_state",
      state: data,
    });
  };


  const refreshState = (onEndFcn = null) => {
    callApi(state.url, "GET", "json", (data) => {
      dispatcher({
        type: "update_state",
        state: data,
      });
      if (onEndFcn) {
        onEndFcn();
      }
    });
  };

  return (
    <div className={`mt-5 pt-5 ${style.CustomizationsPage}`}>
      <CustomizationsPageContext.Provider value={{ state, dispatcher, refreshState }}>
        {state.districts.length > 0 && (
          <div className={`container-fluid`}>
            <CustomizationsPageHeader />
            {
              !(state.bulkActions.isMedicairRespiratory || state.bulkActions.isMedicairLogopedic) && <BulkChangeActions />
            }
            <ExercisesContent />
          </div>
        )}
      </CustomizationsPageContext.Provider>
    </div>
  );
}

CustomizationsPage.propTypes = {};

CustomizationsPage.defaultProps = {};

export const CustomizationsPageContext = React.createContext({});

export default CustomizationsPage;
